import React from 'react';
import { GlobalBridgeContext } from "../context";
export var useGlobalBridge = function useGlobalBridge() {
  var globalBridge = React.useContext(GlobalBridgeContext);
  if (!globalBridge) {
    throw Error('Attempting to useGlobalBridge before declaration. Please wrap App using withGlobalBridge HOC.');
  }
  return globalBridge;
};